


<div class="loader-init text-center d-flex w-100" *ngIf="loader">
    <div class="align-items-center bg-black center-align d-flex flex-column gap-4 justify-content-center loader-box">
      <img src="../../../assets/images/logo.png" width="100" height="100" alt="codesroots">
      <span class="d-block text-center w-100">CodesRoots</span>
    </div>            
</div>